<div class="mb-3" *ngFor="let candidate of candidateList; let i=index;">
  <div class="profile-card">
    <div class="candidate-personal-info-row">
      <div class="left-align-box">
        <div class="">
          <div class="circular-img mr-4 mb-3 text-capitalize position-relative" [ngClass]="{
            'lavender-circle': i % 4 == 0,
            'yellow-circle': i % 4 == 1,
            'blue-circle': i % 4 == 2,
            'teal-circle': i % 5 == 3
          }">{{(candidate.full_name).charAt(0)}}
        </div>
        </div>
      </div>
      <div>
        <div class="candidatename d-flex">
          <p class="text-capitalize mr-2">{{candidate?.full_name}}</p>
          <div *ngIf="candidate?.profiles?.length > 0" class="d-flex">
          <div *ngFor="let profile of candidate?.profiles">
            <div *ngIf="profile.network === 'linkedin' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/linkedin.svg" alt="linkedIn" title="Linkedin">
            </div>
            <div *ngIf="profile.network === 'facebook' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/Facebook.svg" alt="facebook" title="Facebook">
            </div>
            <div *ngIf="profile.network === 'twitter' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/X.svg" alt="twitter" title="Twitter">
            </div>
            <div *ngIf="profile.network === 'github' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/Githib.svg" alt="github" title="Github">
            </div>
            <div *ngIf="profile.network === 'stackoverflow' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/stack_overflow.svg" alt="stackoverflow" title="Stackoverflow">
            </div>
            <div *ngIf="profile.network === 'dribbble' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/dribbble.svg" alt="dribbble" title="Dribbble">
            </div>
            <div *ngIf="profile.network === 'behance' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/behance.svg" alt="behance" title="Behance">
            </div>
            <div *ngIf="profile.network === 'angellist' " class="profile-main-div">
                <img class="source-icon-style mr-1" src="../../assets/svg/angellist.svg" alt="angellist" title="AngelList">
            </div>
        </div>
      </div>
        </div>
        <div class="text-capitalize">
          <span *ngIf="candidate?.job_title"
            [innerHtml]="highlightInfo(candidate?.job_title, 'current_jobtitle', candidate)"></span> <span
            *ngIf="candidate?.job_title && candidate?.job_company_name">at</span>
          <span>{{candidate?.job_company_name}}</span>
        </div>
        <div>
          <span *ngIf="candidate?.location_name" class="text-capitalize"
            [innerHtml]="highlightInfo(candidate?.location_name, 'location', candidate)">
            <i class="fas fa-location-dot"></i></span>
          <span *ngIf="candidate?.location_name && candidate?.totaltenure"><i class="fas fa-circle"></i></span>
          <span *ngIf="candidate?.totaltenure"><i class="fas fa-briefcase"></i>
            {{getFormattedTenure(candidate?.totaltenure)}}</span>
          <span *ngIf="candidate?.totaltenure && candidate?.job_company_industry"><i class="fas fa-circle"></i></span>
          <span *ngIf="candidate?.job_company_industry" class="text-capitalize"><i class="fas fa-industry-windows"></i>
            {{candidate?.job_company_industry}}</span>
        </div>
      </div>
    </div>
    <div class="candidate-highlights-row" *ngIf="candidate?.highlightsInfo?.length">
      <div class="left-align-box">
        <div>
          <p>Highlights</p>
        </div>
      </div>
      <div>
        <div class="highlights-labels" *ngFor="let info of candidate?.highlightsInfo">
          <span class="pointer" [ngClass]="{'highlight-label-pink': info?.displayname == 'Fortune-500', 'highlight-label-green': info?.displayname == 'Techie',
        'highlight-label-blue': info?.displayname == 'Multi-industry', 'highlight-label-purple': info?.displayname == 'Tier-1 School', 'highlight-label-yellow': info?.displayname == 'Unicorn'}"  (click)="startFreeTrial('Get_Highlights_Free_Trial')">
            <span *ngIf="info?.displayname != 'Unicorn'"><i class="fas " [ngClass]="{'fa-building': info?.displayname == 'Fortune-500',
              'fa-microchip-ai': info?.displayname == 'Techie',
            'fa-industry-windows': info?.displayname == 'Multi-industry',
            'fa-school': info?.displayname == 'Tier-1 School'}"></i>{{info?.displayname}}</span>
            <span *ngIf="info?.displayname == 'Unicorn'">
              <img class="briefcase-blank" src="../../../assets/svg/unicorn.svg" alt="Unicorn" />
              {{info?.displayname}}
            </span>
          </span>


        </div>
      </div>
    </div>
    <div class="candidate-exp-row">
      <div class="left-align-box">
        <div>
          <p>Current Exp.</p>
        </div>
      </div>
      <div *ngIf="candidate?.experience?.length > 0" class="text-capitalize">
        <p class="text-capitalize"><span *ngIf="candidate?.experience[0]?.title?.name"
            [innerHtml]="highlightInfo(candidate?.experience[0]?.title?.name, 'current_jobtitle', candidate)"></span>
          <span *ngIf="candidate?.experience[0]?.title?.name && candidate?.experience[0]?.company?.name">at</span>
          <span *ngIf="candidate?.experience[0]?.company?.name"> {{candidate?.experience[0]?.company?.name}}</span>
        </p>
        <span *ngIf="candidate?.experience[0]?.start_date"><i class="fas fa-circle"></i></span>
        <span>{{candidate?.experience[0]?.start_date | date: 'MMM yy'}}</span>
        <span *ngIf="candidate?.experience[0]?.start_date"> - </span>
        <span *ngIf="candidate?.experience[0]?.start_date">Current</span>
        <span *ngIf="candidate?.total_experience_count"  (click)="startFreeTrial('Get_Total_Experience_Free_Trial')">+{{candidate?.total_experience_count}} more</span>
      </div>
    </div>
    <div class="candidate-exp-row" *ngIf="candidate?.education?.length">
      <div class="left-align-box">
        <div>
          <p>Education</p>
        </div>
      </div>
      <div *ngIf="candidate?.education?.length">
        <p class="text-capitalize"><span
            *ngIf="candidate?.education[0]?.degrees[0]">{{candidate?.education[0]?.degrees[0]}}</span>
          <span *ngIf="candidate?.education[0]?.degrees[0] && candidate?.education[0]?.school?.name">at</span>
          <span *ngIf="candidate?.education[0]?.school?.name">{{candidate?.education[0]?.school?.name}}</span>
        </p>
        <span><i class="fas fa-circle"></i></span>
        <span class="text-capitalize"
          *ngIf="candidate?.education[0]?.school?.location?.name">{{candidate?.education[0]?.school?.location?.name}}</span>
        <span><i class="fas fa-circle"></i></span>

        <span *ngIf="candidate?.education[0]?.start_date">{{candidate?.education[0]?.start_date}}</span>
        <span *ngIf="candidate?.education[0]?.start_date && candidate?.education[0]?.end_date"> - </span>
        <span *ngIf="candidate?.education[0]?.end_date">{{candidate?.education[0]?.end_date}}</span>
        <span  (click)="startFreeTrial('Get_Total_Education_Free_Trial')">+{{candidate?.total_education_count}} more</span>
      </div>
    </div>
    <div class="candidate-education-row" *ngIf="candidate?.skills?.length">
      <div class="left-align-box">
        <div>
          <p>Matched Skills</p>
        </div>
      </div>
      <div>
        <div *ngFor="let skill of candidate?.skills; let i=index;">
          <p [innerHtml]="highlightInfo(skill, 'skill', candidate)" class="text-capitalize"></p>

          <span *ngIf="i<2" class="mr-1">,</span>
        </div>

        <span  (click)="startFreeTrial('Get_Total_Skills_Free_Trial')">+{{candidate?.total_skills_count}} Other Skills</span>

      </div>
    </div>
    <div class="premium-feature-row">
      <div class="premium-box">
        <div class="premium-feature-text">
          <i class="fas fa-crown"></i> Premium Features
        </div>
        <div class="dropdown-container">
          <div class="webbtree-box">
            <span><img src="../../../assets/images/webbtree-logo.png" class="mr-2 webbtree-logo"></span> <span>Webbtree Verified</span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/Webbtree-Verified.png" alt="">
              </div>
              <p>Webbtree Verified</p>
              <p>Webbtree Verified get human verified contact details to ensure accuracy and reliability of the
                information. Human verification involves research and confirming contact details, through verified
                sources.</p>
            </div>
          </div>
          <div class="webbtree-box">
            <span><img src="../../../assets/images/webbtree-logo.png" class="mr-2 webbtree-logo"></span> <span>Webbtree Introduction </span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/Webbtree-Introduction.png" alt="">
              </div>
              <p>Webbtree Introduction</p>
              <p>Offload your outreach and scheduling activity
                With a Webbtree Introduction We’re here to assist with connecting you to the candidate and arranging your
                first Introduction Call, giving you the freedom to focus on identifying top talent.</p>
            </div>
          </div>
          <div class="webbtree-box">
            <span class="webbtree-logo mr-2"><i class="fa-solid fa-book-user"></i></span> <span>Contact Partners </span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg contact-person">
                <img src="../../../assets/webbtree-freemium/Contact-Partners.png" alt="">
              </div>
              <p>Contact Partners</p>
              <p>Access to multiple contact enrichment partners
                Get contact information instantly found using one of our trusted Contact  Partners -   PIPL, RocketReach,
                PeopleDataLabs, SignalHire, and more.</p>
            </div>
          </div>
          <div class="webbtree-box mr-2">
            <span class="webbtree-logo mr-2"><i class="fa-regular fa-users"></i></span><span>Similar Candidates </span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg similar-cand">
                <img src="../../../assets/webbtree-freemium/Similar-Candidates.png" alt="">
              </div>
              <p>Similar Candidates</p>
              <p>Get AI-recommended profiles based on matching skills and attributes of your ideal profile.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="profile-card-small">
    <div class="candidate-name">
      <p class="text-capitalize mb-1">{{candidate?.full_name}}</p>
      <div class="ml-1" *ngFor="let profile of candidate?.profiles">
        <div *ngIf="profile.network === 'linkedin' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/linkedin.svg" alt="linkedIn" title="Linkedin">
        </div>
        <div *ngIf="profile.network === 'facebook' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/Facebook.svg" alt="facebook" title="Facebook">
            <!-- <span class="text-style">Facebook</span> -->
        </div>
        <div *ngIf="profile.network === 'twitter' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/X.svg" alt="twitter" title="Twitter">
            <!-- <span class="text-style">Twitter</span> -->
        </div>
        <div *ngIf="profile.network === 'github' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/Githib.svg" alt="github" title="Github">
            <!-- <span class="text-style">GitHub</span> -->
        </div>
        <div *ngIf="profile.network === 'stackoverflow' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/stack_overflow.svg" alt="stackoverflow" title="Stackoverflow">
            <!-- <span class="text-style">Stack Overflow</span> -->
        </div>
        <div *ngIf="profile.network === 'dribbble' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/dribbble.svg" alt="dribbble" title="Dribbble">
            <!-- <span class="text-style">Dribbble</span> -->
        </div>
        <div *ngIf="profile.network === 'behance' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/behance.svg" alt="behance" title="Behance">
            <!-- <span class="text-style">Behance</span> -->
        </div>
        <div *ngIf="profile.network === 'angellist' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/angellist.svg" alt="angellist" title="AngelList">
            <!-- <span class="text-style">AngelList</span> -->
        </div>
    </div>
    </div>
    <div class="cand-comp-annd-jobname">
      <p class="text-capitalize mb-0">
      <span *ngIf="candidate?.job_title"
        [innerHtml]="highlightInfo(candidate?.job_title, 'current_jobtitle', candidate)"></span> <span class="at"
        *ngIf="candidate?.job_title && candidate?.job_company_name">at</span>
      <span>{{candidate?.job_company_name}}</span>
      </p>
    </div>
    <div class="cand-loc-and-exp">
      <span *ngIf="candidate?.location_name" class="text-capitalize"
        [innerHtml]="highlightInfo(candidate?.location_name, 'location', candidate)">
        <i class="fas fa-location-dot"></i></span>
      <span *ngIf="candidate?.location_name && candidate?.totaltenure"><i class="fas fa-circle"></i></span>
      <span *ngIf="candidate?.totaltenure"><i class="fas fa-briefcase"></i>
        {{getFormattedTenure(candidate?.totaltenure)}}</span>
      <span *ngIf="candidate?.totaltenure && candidate?.job_company_industry"><i class="fas fa-circle"></i></span>
      <span *ngIf="candidate?.job_company_industry" class="text-capitalize"><i class="fas fa-industry-windows"></i>
        {{candidate?.job_company_industry}}</span>
    </div>
    <div class="small-highlight" *ngIf="candidate?.highlightsInfo?.length">
      <p class="mb-3 text-9696"> Highlights</p>
      <div class="highlights-labels">
        <!-- <span class="highlight-label-pink pointer" *ngFor="let info of candidate?.highlightsInfo" (click)="startFreeTrial()">
          <span ><i class="fas " [ngClass]="{'fa-building': info?.displayname == 'Fortune-500',
            'fa-microchip-ai': info?.displayname == 'Techie',
          'fa-industry-windows': info?.displayname == 'Multi-industry',
          'fa-school': info?.displayname == 'Tier-1 School'}"></i>{{info?.displayname}}</span>
        </span> -->
        <span  *ngFor="let info of candidate?.highlightsInfo">
          <span class="pointer" [ngClass]="{'highlight-label-pink': info?.displayname == 'Fortune-500', 'highlight-label-green': info?.displayname == 'Techie',
          'highlight-label-blue': info?.displayname == 'Multi-industry', 'highlight-label-purple': info?.displayname == 'Tier-1 School', 'highlight-label-yellow': info?.displayname == 'Unicorn'}"  (click)="startFreeTrial()">
              <span *ngIf="info?.displayname != 'Unicorn'"><i class="fas " [ngClass]="{'fa-building': info?.displayname == 'Fortune-500',
                'fa-microchip-ai': info?.displayname == 'Techie',
              'fa-industry-windows': info?.displayname == 'Multi-industry',
              'fa-school': info?.displayname == 'Tier-1 School'}"></i>{{info?.displayname}}</span>
              <span *ngIf="info?.displayname == 'Unicorn'">
                <img class="briefcase-blank" src="../../../assets/svg/unicorn.svg" alt="Unicorn" />
                {{info?.displayname}}
              </span>
            </span>
        </span>
      </div>

    </div>
    <div class="cand-exp-and-education" *ngIf="candidate?.experience?.length > 0">
      <p class="text-9696">Current Exp.</p>
      <div *ngIf="candidate?.experience?.length > 0" class="text-capitalize cand-comp-and-jobname">
          <p class="text-capitalize"><span *ngIf="candidate?.experience[0]?.title?.name"
              [innerHtml]="highlightInfo(candidate?.experience[0]?.title?.name, 'current_jobtitle', candidate)"></span>
            <span class="at" *ngIf="candidate?.experience[0]?.title?.name && candidate?.experience[0]?.company?.name">at</span>
            <span *ngIf="candidate?.experience[0]?.company?.name"> {{candidate?.experience[0]?.company?.name}}</span>
          </p>
        </div>
        <div class="cand-exp">
          <span *ngIf="candidate?.experience[0]?.start_date"><i class="fas fa-circle"></i></span>
          <span>{{candidate?.experience[0]?.start_date | date: 'MMM yy'}}</span>
          <span *ngIf="candidate?.experience[0]?.start_date"> - </span>
          <span *ngIf="candidate?.experience[0]?.start_date">Current</span>
          <span class="more-exp" *ngIf="candidate?.total_experience_count"  (click)="startFreeTrial('Get_Total_Experience_Free_Trial')">+{{candidate?.total_experience_count}} more</span>
        </div>
    </div>
    <div class="cand-exp-and-education" *ngIf="candidate?.education?.length">
      <p class="text-9696">Education</p>
      <div class="cand-comp-and-jobname" *ngIf="candidate?.education?.length">
        <p class="text-capitalize"><span
            *ngIf="candidate?.education[0]?.degrees[0]">{{candidate?.education[0]?.degrees[0]}}</span>
          <span *ngIf="candidate?.education[0]?.degrees[0] && candidate?.education[0]?.school?.name">at</span>
          <span *ngIf="candidate?.education[0]?.school?.name">{{candidate?.education[0]?.school?.name}}</span>
        </p>

      </div>
      <div class="cand-exp">
        <span><i class="fas fa-circle"></i></span>
        <span class="text-capitalize"
        *ngIf="candidate?.education[0]?.school?.location?.name">{{candidate?.education[0]?.school?.location?.name}}</span>
      <span><i class="fas fa-circle"></i></span>

      <span *ngIf="candidate?.education[0]?.start_date">{{candidate?.education[0]?.start_date}}</span>
      <span *ngIf="candidate?.education[0]?.start_date && candidate?.education[0]?.end_date"> - </span>
      <span *ngIf="candidate?.education[0]?.end_date">{{candidate?.education[0]?.end_date}}</span>
      <span class="more-exp"  (click)="startFreeTrial('Get_Total_Education_Free_Trial')">+{{candidate?.total_education_count}} more</span>
      </div>
    </div>
    <div class="cand-match-skill" *ngIf="candidate?.skills?.length">
      <p class="text-9696">Matched Skills</p>
      <div class="skill-set">
        <div *ngFor="let skill of candidate?.skills; let i=index;">
          <span [innerHtml]="highlightInfo(skill, 'skill', candidate)" class="text-capitalize"></span>

          <span *ngIf="i<2" class="mr-1">,</span>
        </div>

        <span class="more-skill"  (click)="startFreeTrial('Get_Total_Skills_Free_Trial')">+{{candidate?.total_skills_count}} Other Skills</span>

      </div>
    </div>
    <div class="premium-feature-small-box mt-3">
      <div class="premium-feature-yellow-box">
        <i class="fas fa-crown"></i> Premium Features
      </div>
      <div id="accordion">
        <div class="card mb-2">
          <div class="card-header pointer" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            <span><img src="../../../assets/images/webbtree-logo.png" class="mr-2 webbtree-logo"></span> Webbtree Verified
          </div>

          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="card-body">

                <div class="verifiedimg">
                  <img src="../../../assets/webbtree-freemium/Webbtree-Verified.png" alt="">
                </div>
                <p>Webbtree Verified</p>
                <p>Webbtree Verified get human verified contact details to ensure accuracy and reliability of the
                  information. Human verification involves research and confirming contact details, through verified
                  sources.</p>

            </div>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-header pointer" id="headingTwo"  data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            <span><img src="../../../assets/images/webbtree-logo.png" class="mr-2 webbtree-logo"></span>  Webbtree Introduction
          </div>
          <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
            <div class="card-body">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/Webbtree-Introduction.png" alt="">
              </div>
              <p>Webbtree Introduction</p>
              <p>Offload your outreach and scheduling activity
                With a Webbtree Introduction We’re here to assist with connecting you to the candidate and arranging your
                first Introduction Call, giving you the freedom to focus on identifying top talent.</p>
            </div>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-header pointer" id="headingThree"  data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            <span><i class="fa-solid fa-book-user" style="color: #04363d;"></i></span> Contact Partners
          </div>
          <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
            <div class="card-body">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/Contact-Partners.png" alt="">
              </div>
              <p>Contact Partners</p>
              <p>Access to multiple contact enrichment partners
                Get contact information instantly found using one of our trusted Contact  Partners -   PIPL, RocketReach,
                PeopleDataLabs, SignalHire, and more.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header pointer" id="headingFour" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              <!-- <button data-testid="auto-app-webbtree-freemium-profile-button-1" class="btn btn-link collapsed" > -->
                <span><i class="fa-solid fa-wand-magic-sparkles mr-1" style="color: #e24e7f;"></i></span>
                <span><i class="fa-solid fa-users text-9696"></i></span>  Similar Candidates
              <!-- </button> -->
          </div>
          <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
            <div class="card-body">
              <div class="verifiedimg similar-cand">
                <img src="../../../assets/webbtree-freemium/Similar-Candidates.png" alt="">
              </div>
              <p>Similar Candidates</p>
              <p>Get AI-recommended profiles based on matching skills and attributes of your ideal profile.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="blur-profile-mobile">
  <img src="../../../assets/webbtree-freemium/Profile-Desktop.png" class="d-none-mobile" alt="">
  <img src="../../../assets/webbtree-freemium/mobile-profile.png" class="d-block-mobile" alt="">
  <div class="mb-1 text-center free-trial">
    <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole"></i></span>
    <p class="f-18 font-weight-600 mb-2">Talent Profiles</p>
    <p class="f-14 mb-4">Upgrade your plan to view all profiles.</p>
    <button data-testid="auto-app-webbtree-freemium-profile-button-2" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Profile_Start_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>
  </div>
</div>
<!-- <div class="mb-3 card-blur-relative">
  <div class="profile-card card-blur">
    <div class="candidate-personal-info-row">
      <div class="left-align-box">
        <div class="profileimg">
          <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
        </div>
      </div>
      <div>
        <div class="candidatename">
          <p> Priyadarshi Rahul Kumar</p>
        </div>
        <div>
          <span> Sr. Software Engineer</span> <span>at</span> <span>Alphabet</span>
        </div>
        <div>
          <span><i class="fas fa-location-dot"></i> Mumbai, India</span>
          <span><i class="fas fa-circle"></i></span>
          <span><i class="fas fa-briefcase"></i> 5 Yrs 3 Months</span>
          <span><i class="fas fa-circle"></i></span>
          <span><i class="fas fa-industry-windows"></i> Computer science</span>
        </div>
      </div>
    </div>
    <div class="candidate-highlights-row">
      <div class="left-align-box">
        <div>
          <p>Highlights</p>
        </div>
      </div>
      <div>
        <div class="highlights-labels">
          <span class="highlight-label-pink">
            <i class="fas fa-building"></i> <span>Fortune 500 Experience</span>
          </span>
          <span class="highlight-label-green">
            <i class="fas fa-microchip-ai"></i> <span>Techie</span>
          </span>
          <span class="highlight-label-blue">
            <i class="fas fa-industry-windows"></i> <span>Industry compatibility</span>
          </span>
          <span class="highlight-label-purple">
            <i class="fas fa-school"></i> <span>Tier 1 School</span>
          </span>
        </div>
      </div>
    </div>
    <div class="candidate-exp-row">
      <div class="left-align-box">
        <div>
          <p>Current Exp.</p>
        </div>
      </div>
      <div>
        <p><span>Sr. Software Engineer</span>
          <span>at</span>
          <span> Alphabet</span>
        </p>
        <span><i class="fas fa-circle"></i></span>
        <span>June 2020</span>
        <span> - </span>
        <span>Current</span>
        <span>+3 more</span>
      </div>
    </div>
    <div class="candidate-exp-row">
      <div class="left-align-box">
        <div>
          <p>Education</p>
        </div>
      </div>
      <div>
        <p><span>Computer Science</span>
          <span>at</span>
          <span>Port City International University</span>
        </p>
        <span><i class="fas fa-circle"></i></span>
        <span>Mumbai, India</span>
        <span><i class="fas fa-circle"></i></span>

        <span>June 2020</span>
        <span> - </span>
        <span>June 2010</span>
        <span>+3 more</span>
      </div>
    </div>
    <div class="candidate-education-row">
      <div class="left-align-box">
        <div>
          <p>Matched Skills</p>
        </div>
      </div>
      <div>
        <span>Backend, data, Python,</span>

        <span>+57 Other Skills</span>
      </div>
    </div>
  </div>
  <div class="premium-feature-row card-blur">
    <div class="premium-box">
      <div class="premium-feature-text">
        <i class="fas fa-crown"></i> Premium Features
      </div>
      <div class="dropdown-container">
        <div class="webbtree-box">
          <span>Ww</span> <span>Webbtree Verified</span>
          <div class="webbtree-verified-box">
            <div class="verifiedimg">
              <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
            </div>
            <p>Webbtree Verified</p>
            <p>Webbtree Verified get human verified contact details to ensure accuracy and reliability of the
              information. Human verification involves research and confirming contact details, through verified
              sources.</p>
          </div>
        </div>
        <div class="webbtree-box">
          <span>Ww</span> <span>Webbtree Verified</span>
          <div class="webbtree-verified-box">
            <div class="verifiedimg">
              <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
            </div>
            <p>Webbtree Introduction</p>
            <p>Offload your outreach and scheduling activity
              With a Webbtree Introduction We’re here to assist with connecting you to the candidate and arranging your
              first Introduction Call, giving you the freedom to focus on identifying top talent.</p>
          </div>
        </div>
        <div class="webbtree-box">
          <span>Ww</span> <span>Webbtree Verified</span>
          <div class="webbtree-verified-box">
            <div class="verifiedimg">
              <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
            </div>
            <p>Contact Partners</p>
            <p>Access to multiple contact enrichment partners
              Get contact information instantly found using one of our trusted Contact  Partners -   PIPL, RocketReach,
              PeopleDataLabs, Nymblr, SignalHire, and more.</p>
          </div>
        </div>
        <div class="webbtree-box">
          <span>Ww</span> <span>Webbtree Verified</span>
          <div class="webbtree-verified-box">
            <div class="verifiedimg">
              <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
            </div>
            <p>Similar Candidates</p>
            <p>Get AI-recommended profiles based on matching skills and attributes of your ideal profile.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="on-blur-free-trial">
    <div class="mb-1 text-center">
      <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole"></i></span>
      <p class="f-18 font-weight-600 mb-2">Talent Profiles</p>
      <p class="f-14 mb-4">Upgrade your plan to view all profiles.</p>
      <button data-testid="auto-app-webbtree-freemium-profile-button-3" class="btn-free-trial-primery" (click)="startFreeTrial()"><i class="fas fa-crown"></i> Start Free Trial</button>
    </div>
  </div>
</div> -->

<!-- <div class="mb-3 insightdetail">
  <div class="profile-card">
    <div class="candidate-personal-info-row">
      <div class="left-align-box">
        <div class="profileimg">
          <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
        </div>
      </div>
      <div>
        <div class="candidatename">
          <p> Priyadarshi Rahul Kumar</p>
        </div>
        <div>
          <span> Sr. Software Engineer</span> <span>at</span> <span>Alphabet</span>
        </div>
        <div>
          <span><i class="fas fa-location-dot"></i> Mumbai, India</span>
          <span><i class="fas fa-circle"></i></span>
          <span><i class="fas fa-briefcase"></i> 5 Yrs 3 Months</span>
          <span><i class="fas fa-circle"></i></span>
          <span><i class="fas fa-industry-windows"></i> Computer science</span>
        </div>
      </div>
    </div>
    <div class="candidate-highlights-row">
      <div class="left-align-box">
        <div>
          <p>Highlights</p>
        </div>
      </div>
      <div>
        <div class="highlights-labels">
          <span class="highlight-label-pink">
            <i class="fas fa-building"></i> <span>Fortune 500 Experience</span>
          </span>
          <span class="highlight-label-green">
            <i class="fas fa-microchip-ai"></i> <span>Techie</span>
          </span>
          <span class="highlight-label-blue">
            <i class="fas fa-industry-windows"></i> <span>Industry compatibility</span>
          </span>
          <span class="highlight-label-purple">
            <i class="fas fa-school"></i> <span>Tier 1 School</span>
          </span>
        </div>
      </div>
    </div>
    <div class="candidate-exp-row">
      <div class="left-align-box">
        <div>
          <p>Current Exp.</p>
        </div>
      </div>
      <div>
        <p><span>Sr. Software Engineer</span>
          <span>at</span>
          <span> Alphabet</span>
        </p>
        <span><i class="fas fa-circle"></i></span>
        <span>June 2020</span>
        <span> - </span>
        <span>Current</span>
        <span>+3 more</span>
      </div>
    </div>
    <div class="candidate-exp-row">
      <div class="left-align-box">
        <div>
          <p>Education</p>
        </div>
      </div>
      <div>
        <p><span>Computer Science</span>
          <span>at</span>
          <span>Port City International University</span>
        </p>
        <span><i class="fas fa-circle"></i></span>
        <span>Mumbai, India</span>
        <span><i class="fas fa-circle"></i></span>

        <span>June 2020</span>
        <span> - </span>
        <span>June 2010</span>
        <span>+3 more</span>
      </div>
    </div>
    <div class="candidate-education-row">
      <div class="left-align-box">
        <div>
          <p>Matched Skills</p>
        </div>
      </div>
      <div>
        <span>Backend, data, Python,</span>

        <span>+57 Other Skills</span>
      </div>
    </div>
    <div class="premium-feature-row">
      <div class="premium-box">
        <div class="premium-feature-text">
          <i class="fas fa-crown"></i> Premium Features
        </div>
        <div class="dropdown-container">
          <div class="webbtree-box">
            <span>Ww</span> <span>Webbtree Verified</span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
              </div>
              <p>Webbtree Verified</p>
              <p>Webbtree Verified get human verified contact details to ensure accuracy and reliability of the
                information. Human verification involves research and confirming contact details, through verified
                sources.</p>
            </div>
          </div>
          <div class="webbtree-box">
            <span>Ww</span> <span>Webbtree Verified</span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
              </div>
              <p>Webbtree Introduction</p>
              <p>Offload your outreach and scheduling activity
                With a Webbtree Introduction We’re here to assist with connecting you to the candidate and arranging your
                first Introduction Call, giving you the freedom to focus on identifying top talent.</p>
            </div>
          </div>
          <div class="webbtree-box">
            <span>Ww</span> <span>Webbtree Verified</span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
              </div>
              <p>Contact Partners</p>
              <p>Access to multiple contact enrichment partners
                Get contact information instantly found using one of our trusted Contact  Partners -   PIPL, RocketReach,
                PeopleDataLabs, Nymblr, SignalHire, and more.</p>
            </div>
          </div>
          <div class="webbtree-box">
            <span>Ww</span> <span>Webbtree Verified</span>
            <div class="webbtree-verified-box">
              <div class="verifiedimg">
                <img src="../../../assets/webbtree-freemium/loginLogo.png" alt="">
              </div>
              <p>Similar Candidates</p>
              <p>Get AI-recommended profiles based on matching skills and attributes of your ideal profile.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="on-blur-free-trial">
    <div class="mb-1 text-center">
      <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole"></i></span>
      <p class="f-18 font-weight-600 mb-2">Talent Profiles</p>
      <p class="f-14 mb-4">Upgrade your plan to view all profiles.</p>
      <button data-testid="auto-app-webbtree-freemium-profile-button-4" class="btn-free-trial-primery" (click)="startFreeTrial()"><i class="fas fa-crown"></i> Start Free Trial</button>
    </div>
  </div>
</div> -->
